import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { ChakraProvider } from '@chakra-ui/react';

import config from './config';
import App from './components/App';
import { fetchAccountStatusSuccess, loginSuccess } from './actions/auth/actionCreators';
import { getAccountStatus } from './actions/profile/apiRequests';
import { extendTheme } from '@chakra-ui/react';

// reducers
import auth from './reducers/auth';
import tests from './reducers/tests';
import profile from './reducers/profile';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-toggle/style.css';
import '@fontsource/poppins';
import '@fontsource/rubik-beastly';
import '@fontsource/news-cycle';

import './styles/index.css';

const theme = extendTheme({
  fonts: {
    body: `'Poppins', sans-serif`,
  },
  breakpoints: {
    sm: '320px',
    md: '769px',
    lg: '1170px',
    xl: '1280px',
    '2xl': '1536px',
  },
});

const store = createStore(
  combineReducers({
    auth,
    tests,
    profile,
  }),
  composeWithDevTools(applyMiddleware(thunk)),
);

const jwtToken = Cookies.get(config.jwtCookieName);

// TODO: validate token
if (jwtToken) {
  try {
    store.dispatch(loginSuccess(jwtDecode(jwtToken).jti));
  } catch (e) {
    console.error(e);
  }

  getAccountStatus()
    .then(({ eula }) => {
      store.dispatch(fetchAccountStatusSuccess(eula));
    })
    .catch((e) => console.error(e));
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <Router>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </Router>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// src/index.jsx